import React, { ReactNode } from 'react';
import { Icon } from '../../../Icon';
import { PhotosGrid } from '../PhotosGrid';
import { Photo } from '../../../../graphql/types';
import VipIcon from '../../../../public/static/images/item/vip.svg';
import PremiumIcon from '../../../../public/static/images/item/feature.svg';
import {
  CounterText,
  SliderInfoButtonsContainer,
  SliderInfoContainer,
  SliderInfoCounter
} from './styled';

interface SliderInfoProps {
  isVippedShown?: boolean;
  isFeaturedShown?: boolean;
  photos?: Photo[];
  description?: ReactNode;
  pageNumber: number;
  isAuthor: boolean;
  isPublished: boolean;
  itemId: string;
  isReported: boolean;
  isFavorited: boolean;
  setFavorited: React.Dispatch<React.SetStateAction<boolean>>;
  onOpenGallery: (
    e: React.SyntheticEvent<HTMLDivElement>,
    photoNumber?: number
  ) => void;
  setIsAdReported: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SliderInfo: React.FC<SliderInfoProps> = ({
  isVippedShown,
  isFeaturedShown,
  photos,
  description,
  pageNumber,
  isAuthor,
  isPublished,
  itemId,
  isReported,
  isFavorited,
  setFavorited,
  onOpenGallery,
  setIsAdReported
}) => {
  const counter = `${pageNumber || 1}/${photos?.length}`;

  return (
    <SliderInfoContainer>
      <SliderInfoButtonsContainer data-cy="cur-item-gallery__info-container-icons">
        {isFeaturedShown && (
          <Icon
            indent={false}
            width={15}
            height={13}
            IconComponent={PremiumIcon}
          />
        )}
        {isVippedShown && (
          <Icon indent={false} width={15} height={13} IconComponent={VipIcon} />
        )}
      </SliderInfoButtonsContainer>

      <SliderInfoCounter data-cy="cur-item-gallery__info-container-counter">
        <CounterText tag="caption_1_new">{counter}</CounterText>
      </SliderInfoCounter>

      <PhotosGrid
        photos={photos}
        description={description}
        pageNumber={pageNumber}
        isAuthor={isAuthor}
        isPublished={isPublished}
        itemId={itemId}
        isReported={isReported}
        isFavorited={isFavorited}
        setFavorited={setFavorited}
        onOpenGallery={onOpenGallery}
        setIsAdReported={setIsAdReported}
      />
    </SliderInfoContainer>
  );
};
